module.exports = __webpack_public_path__ + "img/img_photovoltaic.4acd5aad.png";